'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicAccountTypes = require('@gig/magic-account-types');
var tslib = require('tslib');
var index = require('../../config/index.js');
var magicMessages = require('@gig/magic-messages');
var getIsTwoFactorAuthOptionEnabled = require('../shared/getIsTwoFactorAuthOptionEnabled.js');
var getFromConfigQuery = require('../shared/getFromConfigQuery.js');
var getFeatureEnable = require('../shared/getFeatureEnable.js');

function UKGCSignupFormConfig(NEXT_BUTTON_ENABLED) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var mailCheck, unmaskPassword, mailCheckConfig, passwordValidationConditions, _a;
        var _b;
        return tslib.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getFeatureEnable.getMailCheckFeatureEnabled()];
                case 1:
                    mailCheck = _c.sent();
                    return [4 /*yield*/, getFeatureEnable.getUnmaskPasswordFeature()];
                case 2:
                    unmaskPassword = _c.sent();
                    return [4 /*yield*/, getFromConfigQuery.getMailCheckConfig()];
                case 3:
                    mailCheckConfig = _c.sent();
                    return [4 /*yield*/, getFromConfigQuery.getPasswordValidationConditions()];
                case 4:
                    passwordValidationConditions = _c.sent();
                    _a = [{
                            name: 'step-1',
                            path: magicAccountTypes.SIGN_UP_STEPS.STEP_1,
                            // Components for step 1
                            components: [
                                index.formConfigs.progressBar1of3(),
                                index.formConfigs.email({
                                    mailCheck: mailCheck,
                                    mailCheckConfig: mailCheckConfig,
                                }),
                                index.formConfigs.password({
                                    passwordValidationConditions: passwordValidationConditions,
                                    unmaskPassword: unmaskPassword,
                                }),
                                index.formConfigs.passwordIndicator(passwordValidationConditions),
                            ],
                            nextButton: {
                                text: magicCommon.translate('sign-up-step-one.button'),
                                alwaysEnabled: NEXT_BUTTON_ENABLED,
                            },
                        }];
                    _b = {
                        name: 'step-2',
                        path: magicAccountTypes.SIGN_UP_STEPS.STEP_2
                    };
                    return [4 /*yield*/, UKGCStep2Components()];
                case 5: return [2 /*return*/, _a.concat([
                        (
                        // Components for step 2
                        _b.components = _c.sent(),
                            _b.nextButton = {
                                text: magicCommon.translate('sign-up-step-two.button'),
                                alwaysEnabled: NEXT_BUTTON_ENABLED,
                            },
                            _b.errorMessage = magicCommon.translate('sign-up-step-two.error'),
                            _b)
                    ])];
            }
        });
    });
}
function UKGCStep2Components() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var addressAutocompleteEnabled, amendDobHint, minimumAge, maximumAge, personalIdConfig, ibanConfig, phoneConfig, isLockedCountry, isLockedCurrency, twoFactorAuthOptionEnabled, collapsibleMarketingPreferences, securityQuestionsConfig;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.getFeatureEnabled(magicMessages.Feature.ADDRESS_AUTOCOMPLETE)];
                case 1:
                    addressAutocompleteEnabled = _a.sent();
                    return [4 /*yield*/, getFeatureEnable.getAmendDobHintFeature()];
                case 2:
                    amendDobHint = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getMinimumAge()];
                case 3:
                    minimumAge = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getMaximumAge()];
                case 4:
                    maximumAge = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getPersonalIdConfig()];
                case 5:
                    personalIdConfig = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getIbanConfig()];
                case 6:
                    ibanConfig = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getPhoneConfig()];
                case 7:
                    phoneConfig = _a.sent();
                    isLockedCountry = true;
                    isLockedCurrency = true;
                    return [4 /*yield*/, getIsTwoFactorAuthOptionEnabled.isTwoFactorAuthOptionEnabled()];
                case 8:
                    twoFactorAuthOptionEnabled = _a.sent();
                    return [4 /*yield*/, getFeatureEnable.getCollapsibleMarketingPreferencesFeature()];
                case 9:
                    collapsibleMarketingPreferences = _a.sent();
                    return [4 /*yield*/, getFromConfigQuery.getSecurityQuestionsConfig()];
                case 10:
                    securityQuestionsConfig = _a.sent();
                    return [2 /*return*/, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([
                            index.formConfigs.progressBar2of3(),
                            tslib.__assign(tslib.__assign({}, index.formConfigs.firstName()), { converter: function (formValue) {
                                    return { firstName: formValue.firstName.value };
                                } }),
                            tslib.__assign(tslib.__assign({}, index.formConfigs.lastName()), { converter: function (formValue) {
                                    return { lastName: formValue.lastName.value };
                                } }),
                            tslib.__assign(tslib.__assign({}, index.formConfigs.gender()), { converter: function (formValue) {
                                    return { sexId: formValue.sex.value };
                                } }),
                            index.formConfigs.birthDate({
                                amendDobHint: amendDobHint,
                                minimumAge: minimumAge,
                                maximumAge: maximumAge,
                            }),
                            index.formConfigs.personalID(personalIdConfig),
                            addressAutocompleteEnabled
                                ? index.formConfigs.addressAutocomplete()
                                : index.formConfigs.address(),
                            index.formConfigs.city(),
                            tslib.__assign(tslib.__assign({}, index.formConfigs.country(isLockedCountry)), { converter: function (formValue) {
                                    return { nationalityCode: formValue.country.value };
                                } }),
                            index.formConfigs.postCode(),
                            index.formConfigs.iban(ibanConfig),
                            index.formConfigs.currency(isLockedCurrency)
                        ], (securityQuestionsConfig.enabled
                            ? [
                                index.formConfigs.securityQuestion(),
                                index.formConfigs.securityAnswer({
                                    securityAnswerMaxLength: securityQuestionsConfig.maxLength,
                                }),
                            ]
                            : [])), [
                            index.formConfigs.phone(phoneConfig)
                        ]), (twoFactorAuthOptionEnabled ? [index.formConfigs.twoFactor()] : [])), [
                            index.formConfigs.consent({
                                collapsibleMarketingPreferences: collapsibleMarketingPreferences,
                            }),
                        ])];
            }
        });
    });
}

exports.UKGCSignupFormConfig = UKGCSignupFormConfig;
